import { GetLevelDistributionDataAPIResponse } from 'types';

export const generateMinLevelForSlider = (
	recommendedLevel: number,
	distribution?: GetLevelDistributionDataAPIResponse,
) => {
	const ranges = distribution?.salaryDistributionData?.map(d => d.range.min) || [];
	const minLevel = Math.min(...ranges, 1000);
	console.log({ minLevel });
	return Math.max(Math.max(minLevel, Math.round((Number(recommendedLevel) - 300) / 10) * 10), 0);
};

export const generateMaxLevelForSlider = (
	recommendedLevel: number,
	distribution?: GetLevelDistributionDataAPIResponse,
) => {
	const ranges = distribution?.salaryDistributionData?.map(d => d.range.max) || [];
	const maxLevel = Math.max(...ranges, 0);
	return Math.min(Math.min(maxLevel, Math.round((Number(recommendedLevel) + 300) / 10) * 10), 1000);
};
